/*===== uniAdapter =====*/
import { isEmpty } from 'script/common';

export const initResourceType = 'store';
export const fileVO = [{ key:'name', value:'', resource: initResourceType }, { key:'size', value:'', resource: initResourceType }]

export function jsonToCascader (jsonData) {	
	const iterate = (data) => {
		if (Array.isArray(data)) {
			return data.map((item) => iterate(item));
		} else {
			const value = transformJsonToCascaderOptions(data);
			return value.length && value[0]
		}
	}

	return iterate(jsonData)
}

export function extractFilePath(webofficeUrl) {
	const regex = /api\/[^\/]+\/(.+?)\/open\?/;
	const match = webofficeUrl.match(regex);
	
	if (match && match[1]) {
		return match[1]; // filePath를 반환
	} else {
		return null; // 일치하는 값이 없을 경우 null 반환
	}
}

export function transformJsonToCascaderOptions(jsonData) {

	const iterate = (data, currentKey = null, parentKey = null) => {
		// 데이터가 배열인 경우, 배열 내의 각 항목을 재귀적으로 처리
		if (Array.isArray(data)) {
			return data.map(item => iterate(item, currentKey, parentKey ? `${parentKey}.${currentKey}` : `${currentKey}`));
		}

		// 데이터가 객체인 경우
		else if (typeof data === 'object' && data !== null) {
			const keys = Object.keys(data);

			// 각 객체의 모든 키를 처리하여 Cascader의 label과 value로 사용
			return keys.map(key => {
				const currentData = data[key];
				const children = iterate(currentData, key, parentKey ? `${parentKey}.${key}` : `${key}`);

				return {
					label: key,
					value: key,
					path: parentKey ? `${parentKey}.${key}` : `${key}`, 
					children: children.length > 0 ? children : undefined,
					originalData: currentData
				};
			});
		}

		// 데이터가 원시 값인 경우, 이를 그대로 label과 value로 사용
		else {
			return {
				label: data,
				value: data,
				path: `${parentKey}.${data}`,
				originalData: undefined, 
				children: undefined
			};
		}
	};

	// 최상위 데이터에 대해 iterate 함수를 호출
	return iterate(jsonData);
};

export function findValueInSource(sourceData, findKeys) {
	if (isEmpty(findKeys)) return;

	let foundValue;
	let currentData = sourceData;
	for (const key of findKeys) {
		foundValue = currentData.find(item => item.label === key);
		if (foundValue) {
			currentData = foundValue.children || [];
		} else {
			return null;
		}
	}

	return foundValue.originalData;
};

const PLACEHOLDER_REGEX = /{([^{}]+)}/g;

export function findValueReplace(responseSourceData, value) {
	if (isEmpty(value)) return;

	if (typeof value !== 'string') return value;
	if (value.length > 10000) {
		return value;
	}
	
	return value.replace(PLACEHOLDER_REGEX, (match, key) => {
		const keyParts = key.split('.');
		const foundValue = findValueInSource(responseSourceData, keyParts);

		if (foundValue === null) {
			return match;
		} else {
			try {
				return (typeof foundValue === 'object') ? JSON.stringify(foundValue, null, 2) : foundValue
			} catch (err) {
				return ''
			}
		}
	});
}

export function updatedSetValue(setValue, responseSource) {
	return setValue.map((data) => {
		const { value: _value } = data;
	
		if (!isEmpty(_value)) {
			const _valueIsValid = findValueReplace(responseSource, _value);
			return {
				...data,
				valueIsValid: _valueIsValid
			};
		}
		return data;
	});
}

export function setFormFieldValue(form, index, key, value) {
	return form.setFieldsValue({
		setValue: form.getFieldValue('setValue').map((item, idx) =>
			idx === index ? { ...item, [key]: value } : item )
	});
	
}
